import { Observable } from 'rxjs';
import { Injectable, Optional, Inject, InjectionToken } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { ConfigService } from '@services/webFeeder/config.service';
import { TOKEN_INTERCEPTOR_MULTIBROKER_LIST } from './token-negotiation.interceptor';


export const TOKEN_INTERCEPTOR_BLOCK_LIST = new InjectionToken<RegExp[]>('Configuration for token interceptor');

@Injectable({
  providedIn: "root"
})
export class TokenInterceptor implements HttpInterceptor {
  multibroker_list: RegExp[] = [];
  block_list: RegExp[] = [];

  constructor(
    private _configService: ConfigService,
    @Optional() @Inject(TOKEN_INTERCEPTOR_BLOCK_LIST) block_list: RegExp[],
    @Optional() @Inject(TOKEN_INTERCEPTOR_MULTIBROKER_LIST) multibroker_list: RegExp[]) {

        if (block_list) { this.block_list = block_list; }
        if (multibroker_list) {
          this.multibroker_list = multibroker_list;
        }

    if (block_list) { this.block_list = block_list; }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addAuthenticationToken(request))
  }

  blocklistCheckup($url: string): boolean {
    let returnValue = false;

    for (const i of Object.keys(this.block_list)) {
      if (this.block_list[i].exec($url) !== null) {
        returnValue = true;
        break;
      }
    }
    return returnValue;
  }

  multiBrokerServiceCheck($url: string): boolean {
    let returnValue = false;

    for (const i of Object.keys(this.multibroker_list)) {
      if (this.multibroker_list[i].exec($url) !== null) {
        returnValue = true;
        break;
      }
    }

    return returnValue;
  }


  addAuthenticationToken(request) {
    let accessToken = this._configService.getTokenApi();

    if (accessToken && this.multiBrokerServiceCheck(request.url)) {
      const tempAccessToken = this._configService.getUserMarketData()?.tknApi;
      accessToken = tempAccessToken ?? accessToken;
    }

    if (!accessToken || this.blocklistCheckup(request.url) ) {
      return request;
    }

    return request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + accessToken
      }
    });
  }

}
